import {
    GET_ALL_CALENDAR_REQUEST,
    GET_ALL_CALENDAR_SUCCESS,
    GET_ALL_CALENDAR_ERROR,
    CREATE_CALENDAR_SUCCESS,
    CREATE_CALENDAR_REQUEST,
    CREATE_CALENDAR_ERROR,
    UPDATE_CALENDAR_SUCCESS,
    UPDATE_CALENDAR_REQUEST,
    UPDATE_CALENDAR_ERROR,
    DELETE_CALENDAR_SUCCESS,
    DELETE_CALENDAR_REQUEST,
    DELETE_CALENDAR_ERROR,
} from "./types.js";
import axios from "axios";
import { BASEURL } from "../../constant/config.js";
import moment from "moment";



export const getAllCalendar = (token, data) => (dispatch) => {
    dispatch({ type: GET_ALL_CALENDAR_REQUEST });
    return axios({
        method: "POST",
        url: `${BASEURL}getAll/CalendarEvents`,
        headers: {
            Accept: "application/json",
            Authorization: "Bearer " + token,
        },
        data: {
            from_date: data?.from_date ? data.from_date : null,
            to_date: data?.to_date ? data.to_date : null,
        },
    })
        .then((response) => {
            
            return dispatch({
                type: GET_ALL_CALENDAR_SUCCESS,
                payload: response.data,
            });
        })
        .catch((error) => {
            dispatch({
                type: GET_ALL_CALENDAR_ERROR,
                payload: [],
            });
        });
};


export const addCalendar = (token, data) => (dispatch) => {
    dispatch({ type: CREATE_CALENDAR_REQUEST });
    return axios({
        method: "POST",
        url: `${BASEURL}create/AddCalendarEvents`,
        headers: {
            Accept: "application/json",
            Authorization: "Bearer " + token,
        },
        data: {
            date: moment(data.eventDate).format("YYYY-MM-DD"),
            events: data.events
        },
    })
        .then((response) => {
            return dispatch({
                type: CREATE_CALENDAR_SUCCESS,
                payload: response.data,
            });
        })
        .catch((error) => {
            dispatch({
                type: CREATE_CALENDAR_ERROR,
                payload: [],
            });
        });
};

export const updateCalendar = (token, data) => (dispatch) => {
    dispatch({ type: UPDATE_CALENDAR_REQUEST });
    return axios({
        method: "PUT",
        url: `${BASEURL}update/UpdateCalendarEvents/${moment(data.eventDate).format("YYYY-MM-DD")}`,
        headers: {
            Accept: "application/json",
            Authorization: "Bearer " + token,
        },
        data: {
            date: moment(data.eventDate).format("YYYY-MM-DD"),
            events: data.events,
            // sno: data.sno
        },
    })
        .then((response) => {
            return dispatch({
                type: UPDATE_CALENDAR_SUCCESS,
                payload: response.data,
            });
        })
        .catch((error) => {
            dispatch({
                type: UPDATE_CALENDAR_ERROR,
                payload: [],
            });
        });
};


export const deleteCalendar = (token, date) => (dispatch) => {
    dispatch({ type: DELETE_CALENDAR_REQUEST });
    return axios({
        method: "DELETE",
        url: `${BASEURL}delete/CalendarEvent/${moment(date).format("YYYY-MM-DD")}`,
        headers: {
            Accept: "application/json",
            Authorization: "Bearer " + token,
        },
       
    })
        .then((response) => {
            return dispatch({
                type: DELETE_CALENDAR_SUCCESS,
                payload: response.data,
            });
        })
        .catch((error) => {
            dispatch({
                type: DELETE_CALENDAR_ERROR,
                payload: [],
            });
        });
};
